// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const { mapDispatchToProps } = require('client-v2/common/containers/auth-modal/actions-component')
// Entry imports
const TopCallToActionExperimentASplitTrailing = require('./split-trailing-dumb')

function mapStateToProps(state) {
  return {
    article: state.topCallToAction.article,
    collection: state.topCallToAction.collection,
    placeholderImage: state.env.articlePlaceholder
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    TopCallToActionExperimentASplitTrailing
  )
)
